import axios from 'axios'
import queryString from 'query-string'
import { getToken } from 'services'

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-type': 'application/json',
  },
  paramsSerializer: (params) => queryString.stringify(params),
  withCredentials: true,
})

axiosClient.interceptors.request.use(
  async (config) => {
    const token = getToken()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    throw error
  }
)

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data
    }
    return response
  },
  (error) => {
    throw error
  }
)

export default axiosClient
